/** @format */

import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import { separator } from "./pxSeparator";
import { useSelector } from "react-redux";
import { STYLE_CHANGE } from "../../../store/constants/action-types";
import { basicProps } from "../ComponentDesigner/ComponentViewer/shared/BasicProps";
import ColorPicker from "material-ui-color-picker";


const useStyles = makeStyles((theme) => ({
  root: {
    background: "#ECECEC",
    display: "inline-block",
    padding: "1px",
    marginLeft: "7px",
    userSelect: "none",
  },
  icons: {
    cursor: "pointer",
    fontSize: "11px",
    marginLeft: "6px",
  },
  input: {
    background: "#ECECEC",
    border: 0,
    outline: "none",
    width: "45px",
    padding: "1px",
    height: "16px",
    fontSize: "12px",
    fontWeight: "bold",
    marginLeft: "5px",
    "&$input[type=number]::-webkit-inner-spin-button": {
      display: "none",
    },
  },
  selectSpan: {
    display: "inline-block",
    marginLeft: "4px",
  },
  select: {
    cursor: "not-allowed",
    background: "#ECECEC",
    fontSize: "14.7px",
  },
  noBorder: {
    border: 0,
    height: "20px",
    paddingTop: "4px",
  },
  title: {
    width: "60px",
  },
}));

const BoxShadow = () => {
  const classes = useStyles();
  let { selectedPropertiesScreenID, components } = basicProps();
  let component = components[selectedPropertiesScreenID];
  let val = "-25px -25px 0px -25px #000000";
  if (component.properties) {
    val = component.properties.styles.boxShadow || "-25px -25px 0px -25px #000000";
  }
  let allValues = val && val.split(" ") || [];
  return (
    <>
      <tr>
        <td colSpan="3" className={`${classes.noBorder} ${classes.title}`}>Horizontal</td>
        <td className={classes.noBorder}>
          <div className={classes.root}>
            <i
              className={`${classes.icons} fas fa-chevron-left`}
              onClick={() => handleDecrease()}
            ></i>
            <i
              className={`${classes.icons} fas fa-chevron-right`}
              onClick={() => handleIncrease()}
            ></i>
            <input
              type="number"
              className={classes.input}
              value={separator(allValues[0])}
              onChange={(e) => updateAndDispatch(e.target.value, 0)}
            />
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan="3" className={`${classes.noBorder} ${classes.title}`}>Vertical</td>
        <td className={classes.noBorder}>
          <div className={classes.root}>
            <i
              className={`${classes.icons} fas fa-chevron-left`}
              onClick={() => handleDecrease()}
            ></i>
            <i
              className={`${classes.icons} fas fa-chevron-right`}
              onClick={() => handleIncrease()}
            ></i>
            <input
              type="number"
              className={classes.input}
              value={separator(allValues[1])}
              onChange={(e) => updateAndDispatch(e.target.value, 1)}
            />
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan="3" className={`${classes.noBorder} ${classes.title}`}>Blur Radius</td>
        <td className={classes.noBorder}>
          <div className={classes.root}>
            <i
              className={`${classes.icons} fas fa-chevron-left`}
              onClick={() => handleDecrease()}
            ></i>
            <i
              className={`${classes.icons} fas fa-chevron-right`}
              onClick={() => handleIncrease()}
            ></i>
            <input
              type="number"
              className={classes.input}
              value={separator(allValues[2])}
              onChange={(e) => updateAndDispatch(e.target.value, 2)}
            />
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan="3" className={`${classes.noBorder} ${classes.title}`}>Radius Spread</td>
        <td className={classes.noBorder}>
          <div className={classes.root}>
            <i
              className={`${classes.icons} fas fa-chevron-left`}
              onClick={() => handleDecrease()}
            ></i>
            <i
              className={`${classes.icons} fas fa-chevron-right`}
              onClick={() => handleIncrease()}
            ></i>
            <input
              type="number"
              className={classes.input}
              value={separator(allValues[3])}
              onChange={(e) => updateAndDispatch(e.target.value, 3)}
            />
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan="3" className={`${classes.noBorder} ${classes.title}`}>Color</td>
        <td className={classes.noBorder}>
          <ColorPicker
            name="color"
            defaultValue="#000"
            onChange={handleColor}
            value={allValues[4]}
          />
        </td>
      </tr>
    </>
  );
  function handleDecrease() {
    dispatchAction(Number(val) - 1);
  }
  function handleColor(value) {
    dispatchAction(value, 4, true);
  }
  function handleIncrease() {
    dispatchAction(Number(val) + 1);
  }
  function updateAndDispatch(val, index, isColor = false) {
    dispatchAction(val, index, isColor);
  }
  function dispatchAction(value, index, isColor) {
    const defaults = "-25px -25px 0px -25px #000000";
    if (allValues.length < 5) {
      allValues = defaults.split(" ");
    }
    allValues[index] = (isColor ? value : value + "px");
    console.log("All Values", allValues);
    window.store.dispatch({
      type: STYLE_CHANGE,
      payLoad: {
        index: component.id,
        propertyValue: allValues.join(" "),
        property: "boxShadow",
      },
    });
  }
};

export default BoxShadow;
